<template>
  <div class="contain page1-con" id="Mobile1">
    <headerCmp></headerCmp>
    <navCmp
      :backgroundColor="'rgba(255,255,255,0)'"
      :navColor="'#C8C8C8'"
      :activeColor="'#FFFFFF'"
    ></navCmp>
    <el-container class="myMain">
      <!-- 头部导航 -->
      <el-main>
        <el-col :span="20">
          <div class="content">
            <div class="title-english">
              <!-- <img src="@/assets/image/home/logoNetflixOriginal.png" alt="" /> -->
              China Athletics Certification Service (Beijing) Co., Ltd.
            </div>
            <transition appear enter-active-class="animated bounce">
              <h1>中田认证服务(北京)有限公司</h1>
            </transition>
            <i class="line hidden-md-and-up"></i>
            <transition appear enter-active-class="animated fadeInRight">
              <p v-html="slogan">               
              </p>
            </transition>
          </div>
        </el-col>
      </el-main>
      <transition name="el-fade-in-linear">
        <div class="codeBox hidden-sm-and-downn" v-if="isShowCodeBox">
          <!-- <ul>
            <li></li>
            <li><h3></h3></li>
            <li><span class="el-icon-user"></span></li>
          </ul> -->
          <div class="code">                
            <img src="@/assets/image/qrcode/wechat.jpg" width="100" height="100" alt="" />
            </div>
          <div class="info">扫码添加官方微信a</div>
        </div>
      </transition>

      <div class="connect">
        <ul class="hidden-sm-and-down">
          <!-- <li>
            <i class="el-icon-picture"></i>
            <span>联系客服</span>
          </li> -->
          <!-- <li
            @mouseenter="isShowCodeBox = true"
            @mouseleave="isShowCodeBox = false"
          >
            <i class="el-icon-picture"></i>
            <span>官方微信</span>
          </li> -->
          <li>
            <img src="@/assets/image/qrcode/wechat.jpg" width="100%" height="100%" style="object-fit: unset;" alt="" />
            <div class="wechat-info">扫码添加官方微信</div>
          </li>
        </ul>
        <!-- <img  @mouseenter="isShowCodeBox = true"
            @mouseleave="isShowCodeBox = false"
          class="hidden-md-and-up"
          src="@/assets/image/home/mobile/wx.png"
          alt=""
        /> -->
        <img src="@/assets/image/qrcode/wechat.jpg" class="hidden-md-and-up wechat-qrcode" alt="" />
        <div class="wechat-info hidden-md-and-up">扫码添加官方微信</div>
      </div>
    </el-container>
  </div>
</template>

<script>
import headerCmp from "@/components/common/header.vue";
import navCmp from "@/components/common/navMenu.vue";
import {  info } from "../../../api/aboutUs";
export default {
  name: "page1",
  data() {
    return {
      keyWords: null,
      isShowCodeBox: false,
      slogan: "",//"为了保障竞赛公平和运动健康安全，在中国田径协会的指导下，中田体育扩展认证业务领域，规范认证业务发展，专门成立“中田认证服务中心”，秉承“鉴证品质 成就卓越”，以“权威标准 公正运作 客观评价  科学管理”为质量目标，做体育产业高质量发展的推动者。",
    };
  },
  components: {
    headerCmp,
    navCmp,
  },
  methods: {
    handleSelect(index) {
      /**
       * @description 导航菜单切换
       */

      this.$router.push(index);
    },
  },
  mounted() {     
    info(["slogan"]).then(
        (res) => {
          if (res.errCode == 0) {
            this.slogan = res.data.slogan;          
          } else {
          }
        }
      );},
};
</script>

<style lang="scss">
.page1-con {
  .el-menu-item {
    padding: 0 12px !important;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: none !important;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: none;
  }
  .el-menu-item:focus,
  .el-menu-item:hover {
    background: none !important;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border: none !important;
  }
}
</style>

<style lang="scss" scoped>
.page1-con {
  background: url("~@/assets/image/home/screen1.png");
  background-size: cover;
  height: 100vh;
  width: 100%;

  .el-header {
    padding: 0 !important;
  }
  // position: relative;
  .el-header.nav-menu {
    line-height: 60px;
  }
  .el-header.page1-con {
    display: flex;
    flex-direction: row;
    align-content: center;
  }
  .el-main {
    overflow-x: hidden;
    padding: 0;
    .content {
      padding-top: 20%;
      text-align: left;
      .title-english{
        font-size: 26px;
      }
      h1 {
        font-size: 54px;
        line-height: 54px;
        margin: 20px 0 16px 0;
      }
      p {
        width: 680px;
        font-size: 18px;
        line-height: 26px;
        text-align: justify;
      }
    }
  }
  .codeBox {
    position: absolute;
    top: 40%;
    right: 86px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 10px;
    background-color: #fff;
    color: #666666;
    ul {
      display: flex;
      li {
        margin-left: 4px;
        font-size: 14px;
        h3 {
          margin: 0 4px;
          font-size: 12px;
          font-weight: 400;
        }
        span {
          color: #1989fa;
        }
      }
    }
    .code {
      width: 100px;
      height: 100px;
      margin: 10px 0 6px 0;
    }
  }
  .wechat-info {
    font-size: 14px;
    margin-bottom: 5px;
  }
  .connect {
    position: absolute;
    // top: 50%;
    right: 0;
    top: 40%;
    li {
      width: 122px;// width: 76px;
      // height: 84px;
      display: flex;
      flex-direction: column;
      background-color: rgba(255, 255, 255, 1);
      color: rgba(102, 102, 102, 1);
      font-size: 14px;
      align-content: center;
      i {
        font-size: 24px;
        margin-top: 20px;
      }
    }
    li:last-child {
      border-top: 1px solid #f5f5f5;
    }
    .wechat-qrcode{
      width: .44rem;
      height: .44rem;
      object-fit: unset;
    }
  }
}
//移动端
@media screen and (max-width: 960px) {
  #Mobile1 {
    background: url("../../../assets/image/home/mobile/m-screen1.png");
    background-size: cover;
    height: 6.4rem;

    .content {
      margin-top: 1.6rem;
      margin-left: 0.16rem;
      padding: 0;
      .title-english{
        font-size: .12rem;
      }
      img {
        // width: 1.96rem;
        height: 0.11rem;
      }
      .line {
        display: inline-block;
        width: 0.8rem;
        height: 0.02rem;
        background: #ffffff;
        border-radius: 0.02rem;
        opacity: 0.5;
        margin: 0.16rem 0;
      }
    }
    h1 {
      font-size: 0.22rem;
      line-height: 0.25rem;
      margin: 0.1rem 0 0 0;
    }
    p {
      width: 2.3rem;
      font-size: 0.12rem;
      color: #ffffff;
      line-height: 0.18rem;
    }
    .el-container {
      height: 100%;
      position: relative;
      padding-top: 0.56rem;
    }
    .connect {
      top: 3rem;
      right: 0.16rem;
    }
    .wechat-info {
      font-size: .08rem;
    }
  }
}
</style>